// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import EmotionalQuestions from "../../components/questionnaires/emotionalQuestions";

const EmotionalQuestionsView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <EmotionalQuestions />
    </Main>
  </>
);

export default EmotionalQuestionsView;
